import styled from 'styled-components';
import Link from '@mui/material/Link';

export const TaskLink = styled(Link)`
  font: normal normal 14px/18px Roboto;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
  cursor: pointer;
  margin-left: 4px;
`;
